<template>
  <v-container fluid>
    <v-layout justify-center>
      <v-flex md12>
        <v-card title>
          <v-card-title>
            <h2>Clientes</h2>
          </v-card-title>
          <v-card-text>
            <DataTableMain :datatable="table" :on-success="successAction" :itemsAction="tableAction" />
            <v-col cols="12">
              <v-layout justify-center>
                <v-flex xs12 sm10>
                  <ViewDetails class="ma-5" :object="object" type="ActividadEconomicaCustomer" :itemsAction="tableAction"/>
                </v-flex>
              </v-layout>
            </v-col>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <MainFormDialog v-if="get_dialogMain.dialog" :fields="form" :model="main" :urls="urls" :message="message"/>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMain'
import MainFormDialog from '@/components/dialogs/MainFormDialog'
import ViewDetails from '@/components/ViewDetails'
import XLSX from 'xlsx'
import router from '@/router'
import { Permission } from '@/mixins/permissionMain'
export default {
  mixins: [Permission],
  data: () => ({
    table: {
      modelMain: [],
      showSelect: true,
      singleSelect: true,
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'clientes.store' },
          { title: 'exportar cliente', icon: 'mdi-clipboard-text', color: 'warning', action: 'exportData', code: 'clientes.export' }
        ],
        titles: [
          { text: '', value: 'Actions', class: 'black--text' },
          { text: 'Nombres', value: 'nombres', class: 'black--text' },
          { text: 'Apellidos', value: 'apellidos', class: 'black--text' },
          { text: 'Telefono', value: 'telefono', class: 'black--text' },
          { text: 'Correo', value: 'correo', class: 'black--text' },
          { text: 'Fec. Nacimiento', value: 'fecha_nacimiento', class: 'black--text' },
          { text: 'Estado Civil', value: 'estado_civil', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' },
          { text: 'Fecha de Alta', value: 'Created', class: 'black--text' }
          // { text: 'Fecha Actualizada', value: 'Updated', class: 'black--text' },
        ],
        losading: false
      },
      body: {
        data: [],
        actions: [
          { title: 'Editar', icon: 'mdi-border-color', color: 'yellow darken-2', action: 'toEditData', code: 'clientes.update' },
          { title: 'Eliminar', icon: 'mdi-delete', color: 'red darken-2', action: 'DeleteData', code: 'clientes.delete' },
          { title: 'Eliminar Definitivo', icon: 'mdi-delete', color: 'red darken-2', action: 'DeleteConfirmData', code: 'clientes.delete.confirm' },
          { title: 'Generar Actividad Economica', icon: 'mdi-account-edit', color: 'lime lighten-1', action: 'toGenerateActivityEconom', code: 'clientes-actividad' },
          { title: 'Generar Credito Bancario', icon: 'mdi-account-edit', color: 'lime lighten-1', action: 'toGenerateCredit', code: 'clientes-credito' },
          { title: 'Generar Credito Fovissste', icon: 'mdi-account-edit', color: 'lime lighten-1', action: 'toGenerateCreditFovissste', code: 'clientes-credito-fovissste' }
        ]
      },
      footer: {
        paging: true
      }
    },
    main: {},
    form: [],
    urls: '',
    message: '',
    id: 0
  }),
  components: {
    DataTableMain,
    MainFormDialog,
    ViewDetails
  },
  mounted () {
    const user = this.$cookies.get('user')
    this.id = user.id
    this.PostListObjects({ url: '/clientes', data: { idUser: user.id } })
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
  },
  methods: {
    ...mapActions(['PostListObjects', 'DeleteObject']),
    successAction (item) {
      this[item.action](item)
    },
    refreshData (item) {
      this.table.header.loading = true
      this.PostListObjects({ url: '/clientes', data: { idUser: this.id } })
    },
    newData (item) {
      this.main = {}
      this.form = this.get_CustomerForm
      this.urls = '/clientes/store'
      this.message = 'Registro Agregado Correctamente'
      this.SHOW_DIALOG_MAIN({ type: 'create', with: 850, title: 'Nuevo Cliente' })
    },
    exportData (item) {
      const data = XLSX.utils.json_to_sheet(this.get_objects)
      const workbook = XLSX.utils.book_new()
      // const nameHours = this.getDateAndHour()
      const filename = 'Clientes'
      XLSX.utils.book_append_sheet(workbook, data, filename)
      XLSX.writeFile(workbook, `${filename}.xlsx`)
    },
    tableAction (item) {
      this[item.action](item)
    },
    toEditData ({ item }) {
      this.main = item
      this.form = this.get_CustomerForm
      this.urls = '/clientes/update'
      this.message = 'Registro Actualizado Correctamente'
      this.SHOW_DIALOG_MAIN({ type: 'update', with: 850, title: 'Nuevo Cliente' })
    },
    DeleteData ({ item }) {
      this.$swal.fire({
        title: 'Estas seguro de eliminar el registro?',
        text: 'No podras revertir este movimiento!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, Eliminar!'
      }).then((result) => {
        if (result.value) {
          this.table.header.loading = true
          this.DeleteObject({ url: `/clientes/delete/${item.id}` })
        }
      })
    },
    DeleteConfirmData ({ item }) {
      this.$swal.fire({
        title: 'Estas seguro de eliminar el registro definitivamente?',
        text: 'No podras revertir este movimiento!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, Eliminar!'
      }).then((result) => {
        if (result.value) {
          this.table.header.loading = true
          this.DeleteObject({ url: `/clientes/delete/confirm/${item.id}` })
        }
      })
    },
    toGenerateCredit ({ item }) {
      router.push({ name: 'ViewTipoCreditoCustomer', params: { id: item.id } })
    },
    toGenerateCreditFovissste ({ item }) {
      router.push({ name: 'ViewTipoCreditoFovisssteCustomer', params: { id: item.id } })
    },
    toGenerateActivityEconom ({ item }) {
      router.push({ name: 'ViewActividadEconomicaCustomer', params: { id: item.id } })
    },
    ...mapMutations(['SHOW_DIALOG_MAIN'])
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_objects', 'get_CustomerForm']),
    object () {
      if (this.table.modelMain.length > 0) {
        return this.table.modelMain[0]
      }
      return {}
    }
  },
  watch: {
    get_objects (vals) {
      if (vals) {
        this.table.header.loading = false
        this.table.modelMain = []
        if (vals.length > 0) {
          this.table.modelMain.push(vals[0])
        }
        this.table.body.data = vals
      }
    }
  }
}
</script>

<style></style>
